"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaIdentifierDisplay = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var utils_1 = require("./utils");
var getStringifiedFieldValueFromSchema_1 = require("./utils/getStringifiedFieldValueFromSchema");
function SchemaIdentifierDisplay(_a) {
    var schema = _a.schema, values = _a.values, displayName = _a.displayName;
    var identifier = schema.identifier;
    if (!identifier) {
        return null;
    }
    var title = identifier.title
        .map(function (propertyKey) { return (0, getStringifiedFieldValueFromSchema_1.getStringifiedFieldValueFromSchema)(propertyKey, schema, values); })
        .filter(Boolean)
        .join(' ');
    var subtitle = identifier.subtitle
        .map(function (propertyKey) { return (0, getStringifiedFieldValueFromSchema_1.getStringifiedFieldValueFromSchema)(propertyKey, schema, values); })
        .filter(Boolean)
        .join(' ');
    if (!title && !subtitle) {
        return react_1.default.createElement(core_ui_1.Text, null, "-");
    }
    var subtitleTooltip = displayName
        ? 'Display Name'
        : identifier.subtitle.map(function (value) { return (0, utils_1.getFieldLabel)(value, schema); }).join(', ');
    var titleTooltip = "" + identifier.title.map(function (value) { return (0, utils_1.getFieldLabel)(value, schema); }).join(', ') + (displayName || !title ? ", " + identifier.subtitle.map(function (value) { return (0, utils_1.getFieldLabel)(value, schema); }).join(', ') : '');
    return (react_1.default.createElement(core_ui_1.Flexbox, { flexDirection: "column" },
        react_1.default.createElement(core_ui_1.Tooltip, { text: "Identifier (" + titleTooltip + ")" },
            react_1.default.createElement(core_ui_1.LineClamp, { numOfLines: 2 },
                react_1.default.createElement(core_ui_1.Text, { weight: 600, color: "dark", display: "block" }, displayName ? title + " " + subtitle : title || subtitle))),
        (title || displayName) && (react_1.default.createElement(core_ui_1.Tooltip, { text: subtitleTooltip },
            react_1.default.createElement(core_ui_1.LineClamp, { numOfLines: 1 },
                react_1.default.createElement(core_ui_1.Text, { weight: 400, color: "default", display: "block" }, displayName || subtitle))))));
}
exports.SchemaIdentifierDisplay = SchemaIdentifierDisplay;
